import { Box } from 'front-end/src/components'
import { useLooopTheme } from 'front-end/src/public-api/hooks/useLooopTheme'
import React, { FC } from 'react'
import IconSVG, { IconSVGProps } from '../IconSVG'

type IconFileProp = IconSVGProps & {
  fileExtension?: string
}
const IconFile: FC<IconFileProp> = (props) => {
  const { theme } = useLooopTheme()
  const { fileExtension, fontSize, ...rest } = props
  return (
    <IconSVG
      className="IconFile"
      boxSize="44px"
      {...rest}
      position="relative"
      aria-label={`File icon ${fileExtension}`}
    >
      <svg height="100%" viewBox="0 0 24 32" fill="currentColor">
        <g clipPath="url(#clip0)">
          <mask
            id="a"
            width="25"
            height="32"
            x="0"
            y="0"
            maskUnits="userSpaceOnUse"
            style={{ maskType: 'alpha' }}
          >
            <path fill="#fff" d="M0 0h16.055l8.0275 8v24H0V0z" />
          </mask>
          <g mask="url(#a)">
            <path
              fill={theme.colors.buttonPrimary[400]}
              d="M22.477 0H1.6055C.718806 0 0 .716344 0 1.6v28.8c0 .8837.718806 1.6 1.6055 1.6H22.477c.8867 0 1.6055-.7163 1.6055-1.6V1.6c0-.883656-.7188-1.6-1.6055-1.6z"
            />
            <path
              fill="#1C2732"
              fillOpacity=".25"
              d="M38.5654-24h-20.905c-.8867 0-1.6055.7163-1.6055 1.6V6.36324c0 .88365.7188 1.6 1.6055 1.6h20.905c.8867 0 1.6055-.71635 1.6055-1.6V-22.4c0-.8837-.7188-1.6-1.6055-1.6z"
            />
          </g>
        </g>
      </svg>
      {fileExtension && (
        <Box
          position="absolute"
          left="0px"
          right="0px"
          top="15px"
          textTransform="uppercase"
          color="#fff"
          fontSize={fontSize || '12px'}
          fontWeight="bold"
          textAlign="center"
        >
          {fileExtension}
        </Box>
      )}
    </IconSVG>
  )
}

export default IconFile
